import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DisplayInfo } from 'shared/components';
import { withTranslation } from 'react-i18next';
import { setDemographicInfo, setEducationInfo } from 'features/profile/helpers';

class BackgroundAndEducation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      demographicInfo: setDemographicInfo(props.user, props.t),
      //  backgroundInfo: setBackgroundInfo(props.user, props.races),
      educationInfo: setEducationInfo(props.user, props.t),
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user !== this.props.user) {
      this.setState({
        demographicInfo: setDemographicInfo(this.props.user, this.props.t),
        // backgroundInfo: setBackgroundInfo(this.props.user, this.props.races),
        educationInfo: setEducationInfo(this.props.user, this.props.t),
      });
    }
  }

  render() {
    return (
      <div>
        {/*         <DisplayInfo */}
        {/*           className="pb-4" */}
        {/*           info={this.state.backgroundInfo} */}
        {/*           onEdit={() => this.props.onEdit('background')} */}
        {/*           buttonLabel="common.labels.updateInfo" */}
        {/*         /> */}
        <DisplayInfo
          info={this.state.educationInfo}
          onEdit={() => this.props.onEdit('education')}
          buttonLabel="common.labels.updateInfo"
        />
      </div>
    );
  }
}

BackgroundAndEducation.propTypes = {
  onEdit: PropTypes.func,
  user: PropTypes.shape({}).isRequired,
  t: PropTypes.func.isRequired,
};

BackgroundAndEducation.defaultProps = {
  onEdit: () => {},
};

export default withTranslation()(BackgroundAndEducation);
